/* eslint-disable spellcheck/spell-checker */
import { Injectable } from '@angular/core';

import { AppEventType, PlayerCountChangeEvent } from '../models/communication/app-events.model';
import { AppState } from '../models/communication/app-state.model';
import { YEventPayload } from '../models/y-protocol.model';

export type Plugin = (state: AppState, event: YEventPayload<AppEventType>, containerNode: HTMLElement) => void;

/**
 * Show the animation effect by adding the class and remove it after the animation ends.
 */
const initAnimation = (node: HTMLElement, className: string): void => {
    node.classList.add(className);

    const onAnimationEnd = (): void => {
        node.classList.remove(className);
        node.removeEventListener('animationend', onAnimationEnd);
    };
    node.addEventListener('animationend', onAnimationEnd);
};

/**
 * PluginService exposes the array of plugin functions that get called
 * every time the state or event stream emit values.
 *
 * It is intended for a specific business logic and requirements
 * that would otherwise pollute the app.component with unnecessary details.
 *
 * For now, the function signature is based on the current plugin requirements.
 * In the future, a more general interface should be defined.
 *
 */
@Injectable({
    providedIn: 'root'
})
export class PluginService {
    readonly plugins: Plugin[] = [
        /**
         * Highlight the player count when the number of players increases.
         */
        (state: AppState, { name, data }: YEventPayload<AppEventType>, containerNode: HTMLElement): void => {
            if (name === AppEventType.PlayerCountChange && (data as PlayerCountChangeEvent).count > (state.playerCount || 0)) {
                initAnimation(containerNode, 'highlight-player-count');
            }
        }
    ];
}
